import { useCallback, useState } from 'react'

const useValueState = (initialState) => {
  const [value, setValue] = useState(initialState)

  const handleChange = useCallback((newValue) => {
    setValue(newValue)
  }, [])

  return {
    value,
    handleChange,
  }
}

export default useValueState
